import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AkButton from '@atlaskit/button/custom-theme-button';
import AkMoreIcon from '@atlaskit/icon/core/show-more-horizontal';

const i18n = defineMessages({
	more: {
		id: 'editor-ellipsis-dropdown.placeholder.ellipsis.more',
		description:
			'The text is shown as an accessible label for the More (ellipsis) icon button placeholder in the editor toolbar, used by screen readers to describe the button that reveals additional actions.',
		defaultMessage: 'More',
	},
});

export const EllipsisPlaceholder = () => {
	const intl = useIntl();
	const label = intl.formatMessage(i18n.more);
	const moreIcon = <AkMoreIcon color="currentColor" spacing="spacious" label={label} />;
	return (
		<AkButton testId="ellipsis-placeholder" isDisabled iconBefore={moreIcon} appearance="subtle" />
	);
};
